// Manager coaching callout (approved HTML component: manager-coaching-callout).
import type { ReactNode } from 'react';

export function ManagerCoachingCallout(): ReactNode {
  return (
    <section className="n-callout" data-component="manager-coaching-callout">
      <span className="eyebrow">WHERE YOU CAN HELP</span>
      <h3>Keep the team moving.</h3>
      <p>
        The system handles routine routing. Focus on exceptions, coverage and useful coaching.
      </p>
    </section>
  );
}
